import React, { useEffect, useState } from "react";
import { makeApi, URLS } from "Utils/apiURL";

// Mirrors Components/PreviewPopup/ContactAutoCompleteDropdown.js — same
// debounce/cancel shape, pointed at the account search endpoint instead.
let accountsListNetworkRequest = {
  fetchAccounts: null
};

const setAccountsListNetworkRequest = (id = "") => {
  if (id && accountsListNetworkRequest?.[id] !== null) {
    accountsListNetworkRequest[id]("cancel");
    accountsListNetworkRequest[id] = null;
  }
};

const cancelReqCallback = (id = "", value = "") => {
  id && (accountsListNetworkRequest[id] = value);
};

const AccountAutoCompleteDropdown = ({
  inputText = "",
  selectedCallbk = () => {}
}) => {
  const [accountList, setAccountList] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [isInit, setIsInit] = useState(true);

  const changeAction = (obj = {}) => {
    setShowDropdown(false);
    setKeyword(obj?.name || obj?.domain || "");
    selectedCallbk(obj);
  };

  const renderItem = (obj = {}) => {
    const { id = "", name = "", domain = "" } = obj || {};
    return (
      <li
        key={id}
        id={id}
        className="option"
        onClick={() => changeAction(obj)}
      >
        <div className="listItem">
          <div className="listItemWrap">
            <span className="itemName">{name || domain}</span>
            {name && domain && <span className="itemEmail">{domain}</span>}
          </div>
        </div>
      </li>
    );
  };

  const getAccountsByKeywordSearch = async (value = "") => {
    if (value && keyword?.toLowerCase() !== value?.toLowerCase()) {
      const config = {
        url: URLS.getAccountList,
        method: "POST",
        data: { searchTerm: value, pageNo: 1, limit: 10 }
      };
      setAccountsListNetworkRequest("fetchAccounts");
      const cancel = value => cancelReqCallback("fetchAccounts", value);
      let res = await makeApi(config, cancel);
      if (
        res?.message?.message?.toLowerCase() === "cancel" ||
        res?.message?.toLowerCase() === "cancel"
      ) {
        console.error("Request cancelled");
      } else {
        if (+res?.status === 200) {
          setAccountList(res?.data?.accounts || []);
          setKeyword(value);
          setShowDropdown(true);
        }
      }
    }
  };

  const closeAction = () => {
    setShowDropdown(false);
    setKeyword("");
    setAccountList([]);
  };

  useEffect(() => {
    if (inputText && !isInit) {
      getAccountsByKeywordSearch(inputText);
    } else {
      setAccountList([]);
    }
    !inputText && showDropdown && setShowDropdown(false);
    setIsInit(false);
    setKeyword(inputText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputText]);

  useEffect(() => {
    return () => {
      setIsInit(true);
    };
  }, []);

  return (
    showDropdown &&
    keyword?.trim() && (
      <div className="emailAutoCompleteDropdown">
        <div className="drop-down-menu animatedFast animatedDropDown">
          <ul className="dropdownList">
            {accountList?.length === 0 && (
              <li className="option noOption">No accounts found</li>
            )}
            {accountList?.length > 0 &&
              accountList.map(item => renderItem(item))}
          </ul>
        </div>
        <div className="dropdownMask" onClick={closeAction} />
      </div>
    )
  );
};

export default AccountAutoCompleteDropdown;
export { AccountAutoCompleteDropdown };
